// Version : 0.0.1
// Author : VIGNESH

import goldLoanCollectionActionTypes from './gold-loan-collection-report.types';

/** ***************** GET GOLD LOAN COLLECTION START *********************** */
export const getGoldLoanCollectionDetailsStart = (getData: any) => ({
	type: goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_START,
	payload: getData,
});

export const getGoldLoanCollectionDetailsSuccess = (successData: any) => ({
	type: goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_SUCCESS,
	payload: successData,
});

export const getGoldLoanCollectionDetailsFailure = (failureData: any) => ({
	type: goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_FAILURE,
	payload: failureData,
});

export const getGoldLoanCollectionDetailsResponseResetStart = () => ({
	type: goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_RESPONSE_RESET,
});

export const getGoldLoanCollectionDetailsResponseChanged = () => ({
	type: goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN COLLECTION END *********************** */
